import axios from 'axios'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const BASE_TRADERULE_URL = `${BASE_URL}api/tradeRules/`;
const BASE_COURSE_URL = `${BASE_URL}api/courses/`;

const TradeRuleService = () => ({

    getAllTradeRules: async () => {
        const { data } = await axios.get(`${BASE_TRADERULE_URL}`);
        return data;
    },

    getTradeRules: async (page, pageSize, filters, token) => {

        const { data } = await axios.get(`${BASE_TRADERULE_URL}Paginated`, {
            params: {
                currentPage: page,
                pageSize,
                ...filters
            },
            cancelToken: token
        });
        return data;
    },

    getTradeRule: async (tradeRuleId) => {
        const { data } = await axios.get(`${BASE_TRADERULE_URL}${tradeRuleId}`);
        return data;
    },

    disableTradeRule: async (ruleId) => {
        const { data } = await axios.put(`${BASE_TRADERULE_URL}${ruleId}/disable-rule`);
        return data;
    },
    saveTradeRule: async (tradeRule) => {
        const { data } = await axios.post(`${BASE_TRADERULE_URL}editTradeRule`, tradeRule);
        return data;
    },
    getClasses: async (id) => {
        const { data } = await axios.get(`${BASE_COURSE_URL}${id}/classes`);
        return data;
    },
    getClassGroups: async (id) => {
        const { data } = await axios.get(`${BASE_COURSE_URL}${id}/classGroups`);
        return data;
    },
    getConfig: async (id) => {
        const { data } = await axios.get(`${BASE_COURSE_URL}${id}/configurations`);
        return data;
    },
    editConfig: async (id, config) => {
        const { status } = await axios.put(`${BASE_COURSE_URL}${id}/configurations`, config);
        return status;
    },

    validateTradeRuleName: async (ruleId, ruleName) => {
        const data = await axios.get(`${BASE_TRADERULE_URL}${ruleId}/CheckTradeRuleNameExists?ruleName=${ruleName}`);
        return data;
    },

    createTradeRule: async (tradeRuleDetail) => {
        const { data } = await axios.post(`${BASE_TRADERULE_URL}CreateTradeRule`, tradeRuleDetail);
        return data;
    },
    checkTradeRuleCourseConfigurationExists: async (tradeRuleDetail) => {
        const tradeRuleInfo = tradeRuleDetail;
        const { data } = await axios.post(`${BASE_TRADERULE_URL}CheckTradeRuleCourseConfigurationExists`, tradeRuleInfo);
        return data;
    },
    getCourseClassInfoByRuleId: async (tradeRuleId) => {
        const { data } = await axios.get(`${BASE_TRADERULE_URL}GetCourseClassInfoByRuleId/${tradeRuleId}`);
        return data;
    },

});

export default TradeRuleService;